/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".customRadio[_ngcontent-%COMP%]   label.btn[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]{display:inline-block;position:absolute;width:1px;height:1px;margin:0;opacity:0}.customRadio[_ngcontent-%COMP%]   label.btn[_ngcontent-%COMP%]   input[type=checkbox][_ngcontent-%COMP%]:focus ~ i.far[_ngcontent-%COMP%]{outline:#227882 solid 2px;outline-offset:2px}"];
export { styles as styles };
